import { ReactSVG } from "react-svg";
import { transformDateToLocalDateString } from "helpers";
import { ContactNoteRow } from "services/api/contacts/types";
import { Badge } from "ui/components/Badge";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

/** Stupci bilješki u čarobnjaku kontakta — isti izgled kao popis PP aparata na unosu vozila. */
export const CONTACT_EDIT_NOTE_COLUMNS = (
  handleDeleteClick: (event: React.MouseEvent<HTMLDivElement>, id: string) => void
): Column[] => [
  {
    title: "Bilješka",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactNoteRow) => {
      return (
        <div className="flex items-center gap-2 min-w-0">
          <span className="text-md font-medium text-slate-600 truncate max-w-[300px]">{row.content}</span>
          {row.important && <Badge text="Važna bilješka" variant="warning" height="small" />}
        </div>
      );
    },
  },
  {
    title: "Autor",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactNoteRow) => {
      return (
        <div className="text-sm text-slate-900 truncate">
          {row.userCreated && `${row.userCreated.firstName} ${row.userCreated.lastName}`}
        </div>
      );
    },
  },
  {
    title: "Datum",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactNoteRow) => {
      return (
        <div className="text-sm text-slate-900 truncate">
          {transformDateToLocalDateString(row.created ? new Date(row.created) : null)}
        </div>
      );
    },
  },
  {
    title: "",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactNoteRow) => {
      return (
        <div onClick={(e) => handleDeleteClick(e, row.id)} className="flex justify-end items-center h-[30px]">
          <ReactSVG src={"/media/icons/trash.svg"} className="w-4 h-4 stroke-[#bd0000]" />
        </div>
      );
    },
  },
];
